// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.messages-terms-request-panel {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-width: 0;
}

.messages-terms-request-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  background: #fff;
  border-left: 1px solid #e5e7eb;
  width: 30%;
}

.messages-terms-request-header {
  min-height: 60px;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #edf0f4;
  margin-top: 10px;
}

.messages-terms-request-header-left {
  display: flex;
  align-items: center;
  gap: 10px;
}
.color-text {
  color: #6366f1 !important;
}

.messages-terms-close {
  cursor: pointer;
  color: #99a1af;
  font-size: 14px;
}

.messages-terms-close:hover {
  color: #d2042d;
}

.messages-terms-tabs {
  display: flex;
  height: 42px;
  border-bottom: 1px solid #edf0f4;
}

.messages-terms-tab {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  cursor: pointer;
  color: #99a1af;
  font-size: 12px;
  border-bottom: 2px solid transparent;
}

.messages-terms-tab-active {
  color: #d2042d;
  border-bottom-color: #d2042d;
}

.messages-terms-request-body {
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
  padding: 14px 16px;
}

.messages-terms-product-card {
  padding: 14px;
  background: #f8fafc;
  border: 1px solid #edf0f4;
  border-radius: 10px;
  margin-bottom: 12px;
}

.messages-terms-product-card .common-text-99a1af-11 {
  display: block;
  margin-bottom: 4px;
}

.messages-terms-section-card {
  border: 1px solid #e5e9ef;
  border-radius: 10px;
  overflow: hidden;
}

.messages-terms-section-card > .common-text-101828-14-500 {
  display: block;
  padding: 14px;
  border-bottom: 1px solid #edf0f4;
}

.messages-terms-info-row {
  min-height: 44px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #edf0f4;
}

.messages-terms-info-row:last-child {
  border-bottom: none;
}

.messages-terms-info-box {
  margin-top: 12px;
  padding: 12px;
  border-radius: 9px;
  background: #eef6ff;
  border: 1px solid #d9eaff;
}

.messages-terms-request-card {
  border: 1px solid #e5e9ef;
  border-radius: 10px;
}

.messages-terms-request-total {
  padding: 14px;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #edf0f4;
}

.messages-terms-total {
  text-align: right;
  width: 35%;
}
.messages-terms-form-section {
  padding: 0px;
}
.padding-styles {
  padding: 14px !important;
}
.messages-terms-date-labels {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  margin-bottom: 5px;
}
.alignment-footer {
  display: flex;
  align-items: center;
}
.messages-terms-date-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}

.messages-terms-date-row .ant-picker {
  width: 100%;
}

.messages-terms-payment-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.messages-terms-installment-heading {
  display: flex;
  justify-content: space-between;
  margin-bottom: 6px;
  color: #99a1af;
  font-size: 12px;
}

.messages-terms-installment-row {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  align-items: flex-start;
  margin-bottom: 8px;
  position: relative;
}

.messages-installment-name {
  display: flex;
  align-items: center;
  gap: 7px;
  min-width: 0;
}

.messages-installment-number {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #fff0f3;
  color: #d2042d;
  font-size: 10px;
  font-weight: 600;
}

.messages-terms-installment-row .ant-picker {
  width: 100%;
  background: #ffffff !important;
  border-width: 1px !important;
  border-style: solid !important;
  border-color: #d9d9d9 !important;
}

.messages-installment-percentage {
  display: flex;
  flex-direction: column;
  gap: 2px;
  align-items: center;
}

.messages-installment-percentage .ant-input-number {
  width: 100%;
  background: #ffffff !important;
  border-width: 1px !important;
  border-style: solid !important;
  border-color: #d9d9d9 !important;
}

.messages-installment-delete {
  position: static;
  right: -20px;
  color: #d1d5dc;
  cursor: pointer;
}

.messages-add-installment-button {
  margin-top: 6px;
  height: 34px;
  border: 1px dashed #d2042d;
  color: #d2042d;
  background: #fff;
}

.messages-add-installment-button:hover {
  color: #d2042d !important;
  border-color: #d2042d !important;
}

.messages-terms-allocation {
  margin-top: 10px;
  border-radius: 8px;
  background: #f8fafc;
  overflow: hidden;
  border: 1px solid #e5e7eb;
}

.messages-terms-allocation-info {
  min-height: 32px;
  padding: 7px 10px;

  display: flex;
  align-items: center;
  justify-content: space-between;

  gap: 8px;
}

.messages-terms-allocation-progress {
  width: 100%;
  height: 5px;
  background: #e5e7eb;
  overflow: hidden;
}

.messages-terms-allocation-progress-fill {
  height: 100%;
  background: #d2042d;
  transition: width 0.25s ease;
}

.messages-terms-note-input {
  margin-top: 8px;
  background: #ffffff !important;
  border-width: 1px !important;
  border-style: solid !important;
  border-color: #d9d9d9 !important;
}
.messages-terms-request-footer {
  flex-shrink: 0;
  padding: 10px 16px 14px;
  border-top: 1px solid #edf0f4;
  background: #fff;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.messages-send-terms-button {
  width: 100%;
  height: 38px;
  gap: 0px !important;
}

.messages-terms-cancel-button {
  width: 100%;
  color: #4a5565;
}

.messages-terms-installment-heading {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 6px;
  color: #99a1af;
  font-size: 12px;
}
.messages-terms-installment-heading span:nth-child(1) {
  flex: 1 1;
  min-width: 0;
  text-align: left;
}

.messages-terms-installment-heading span:nth-child(2) {
  flex: 1.15 1;
  min-width: 0;
  text-align: center;
}

.messages-terms-installment-heading span:nth-child(3) {
  flex: 1 1;
  min-width: 0;
  text-align: center;
}

.messages-terms-installment-heading span:nth-child(4) {
  flex: 0 0 16px;
}

.messages-terms-installment-row {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  width: 100%;
  min-width: 0;
  margin-bottom: 8px;
}
.messages-installment-name {
  flex: 1 1;
  min-width: 28%;
  display: flex;
  align-items: center;
  gap: 7px;
}
.messages-installment-number {
  flex: 0 0 20px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #fff0f3;
  color: #d2042d;
  font-size: 10px;
  font-weight: 600;
}

.messages-installment-name .common-text-101828-12 {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.messages-installment-date {
  flex: 1.15 1;
  min-width: 0;
}
.messages-installment-date .ant-picker {
  width: 100%;
  background: #ffffff !important;
  border-width: 1px !important;
  border-style: solid !important;
  border-color: #d9d9d9 !important;
}
.messages-installment-percentage {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
}

.messages-installment-percentage .ant-input-number {
  width: 100%;
  background: #ffffff !important;
  border-width: 1px !important;
  border-style: solid !important;
  border-color: #d9d9d9 !important;
}
.messages-installment-percentage .location-grey-text-12 {
  width: 100%;
  text-align: center;
}

.messages-installment-delete-wrapper {
  flex: 0 0 16px;
  width: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 5px;
}

.messages-installment-delete:hover {
  color: #e53b58 !important;
}

.messages-terms-installment-heading {
  display: flex;
  align-items: center;
  width: 100%;
  gap: 8px;
  margin-bottom: 6px;
  color: #99a1af;
  font-size: 11px;
  line-height: 14px;
}

.installment-col-name {
  flex: 1.05 1;
  min-width: 0;
}

.installment-col-date {
  flex: 1.15 1;
  min-width: 0;
  text-align: center;
}

.installment-col-payment {
  flex: 0.95 1;
  min-width: 0;
  text-align: center;
}

.installment-col-delete {
  flex: 0 0 12px;
  width: 12px;
}

.messages-terms-installment-row {
  display: flex;
  align-items: flex-start;
  width: 100%;
  min-width: 0;
  gap: 8px;
  margin-bottom: 8px;
}

.messages-installment-name {
  flex: 1.05 1;
  min-width: 0;
  height: 42px;
  display: flex;
  align-items: center;
  gap: 7px;
}

.messages-installment-name .common-text-101828-12 {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.messages-installment-number {
  flex: 0 0 20px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #fff0f3;
  color: #d2042d;
  font-size: 10px;
  font-weight: 600;
}

.messages-installment-date {
  flex: 1.15 1;
  min-width: 0;
  height: 42px;
  display: flex;
  align-items: center;
}
.messages-installment-date .ant-picker {
  width: 100%;
  height: 32px;
  background: #fff !important;
  border: 1px solid #d9d9d9 !important;
  border-radius: 8px;
  box-shadow: none !important;
}

.messages-installment-percentage {
  flex: 0.95 1;
  min-width: 0;
  height: 50px;
  display: flex;
  flex-direction: column;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
}

.messages-installment-percent-input {
  height: 23px;
  display: flex;
  align-items: center;
  padding: 0 7px;
  background: #fff;
}

.messages-installment-percent-input .ant-input-number {
  flex: 1 1;
  width: 100%;
  height: 22px;
  padding: 0;
  border: none !important;
  outline: none !important;
  background: transparent !important;
  box-shadow: none !important;
}

.messages-installment-percent-input .ant-input-number-input {
  height: 22px;
  padding: 0;
  font-size: 12px;
  color: #101828;
}

.messages-installment-percent-symbol {
  flex: 0 0 auto;
  margin-left: 4px;
  color: #99a1af;
  font-size: 12px;
}

.messages-installment-amount {
  height: 25px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-top: 1px solid #ffd1d8;
  background: #fff1f3;
  color: #d2042d;
  font-size: 12px;
  font-weight: 500;
}

.messages-installment-delete-wrapper {
  flex: 0 0 12px;
  width: 12px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.messages-installment-percent-input .ant-input-number {
  flex: 1 1;
  width: 100%;
  height: 22px;
  border: none !important;
  background: #fff !important;
  box-shadow: none !important;
}

.messages-installment-percent-input .ant-input-number-input {
  height: 22px;
  padding: 0 4px;
  font-size: 12px;
  color: #101828;
}

.messages-installment-percent-input .ant-input-number-handler-wrap {
  width: 20px;
  background: #fff !important;
  border-left: 1px solid #e5e7eb;
  opacity: 1 !important;
}

.messages-installment-percent-input .ant-input-number-handler {
  height: 11px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff !important;
  border: none !important;
  color: #000 !important;
}
.messages-installment-percent-input .ant-input-number-handler-up-inner,
.messages-installment-percent-input .ant-input-number-handler-down-inner {
  color: #000 !important;
  font-size: 9px;
}

.messages-installment-percent-input .ant-input-number-handler:hover {
  background: #f5f5f5 !important;
}

.messages-installment-percent-input
  .ant-input-number-handler:hover
  .ant-input-number-handler-up-inner,
.messages-installment-percent-input
  .ant-input-number-handler:hover
  .ant-input-number-handler-down-inner {
  color: #000 !important;
}

.messages-installment-percent-input
  .ant-input-number-handler-down-disabled
  .ant-input-number-handler-down-inner,
.messages-installment-percent-input
  .ant-input-number-handler-up-disabled
  .ant-input-number-handler-up-inner {
  color: #999 !important;
}
.messages-installment-percent-input .ant-input-number-handler-up-disabled,
.messages-installment-percent-input .ant-input-number-handler-down-disabled {
  visibility: hidden;
}
.messages-terms-section-header {
  display: flex;
  align-items: center;
  min-height: 38px;
  padding: 0 14px;
  background: #f8fafc;
  border-bottom: 1px solid #edf0f4;
}

.messages-terms-section-header .common-text-101828-14 {
  line-height: 16px;
}
.messages-terms-info-row {
  min-height: 44px;
  padding: 8px 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #edf0f4;
}

.messages-terms-info-row:last-child {
  border-bottom: none;
}
.messages-terms-section-header {
  display: flex;
  align-items: center;
  height: 38px;
  padding: 0 14px;
  background: #f8fafc;
  border-bottom: 1px solid #edf0f4;
}
.messages-terms-request-body {
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
  padding: 14px 16px;
  scrollbar-width: thin;
  scrollbar-color: #98a2b3 transparent;
}
.messages-terms-request-body::-webkit-scrollbar {
  width: 6px;
}

.messages-terms-request-body::-webkit-scrollbar-track {
  background: transparent;
}
.messages-terms-request-body::-webkit-scrollbar-thumb {
  background: #98a2b3;
  border-radius: 10px;
}
.messages-terms-request-body::-webkit-scrollbar-thumb:hover {
  background: #667085;
}

.messages-terms-allocation-complete {
  background: #f0fdf4;
  border-color: #16a34a;
}

.messages-terms-allocation-complete
  .messages-terms-allocation-info
  .location-grey-text-12 {
  color: #008a3e !important;
}

.messages-terms-allocation-complete
  .messages-terms-allocation-info
  .common-text-101828-12-500 {
  color: #008a3e !important;
}

.messages-terms-allocation-complete .messages-terms-allocation-progress {
  background: #dcfce7;
}

.messages-terms-allocation-complete .messages-terms-allocation-progress-fill {
  background: #16a34a;
}
.edit-preview-toggle {
  display: flex;
  width: 100%;
  height: 30px;
  border: 1px solid #d9d9d9;
  border-radius: 10px;
  overflow: hidden;
  background: #fff;
}

.toggle-btn {
  flex: 1 1;
  border: none;
  background: transparent;
  color: #4b5563;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.toggle-btn.active {
  background: #d50032;
  color: #fff;
  font-weight: 600;
}

.toggle-btn:first-child {
  border-radius: 9px 0 0 9px;
}

.toggle-btn:last-child {
  border-radius: 0 9px 9px 0;
}

.toggle-btn:focus {
  outline: none;
}

.seller-payment-schedule {
  width: 100%;
  margin-top: 8px;
}

.seller-payment-schedule-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}

.seller-payment-add-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  height: 28px;
  padding: 0 10px;
  border: 1px dashed #cbd5e1;
  border-radius: 9px;
  background: #fff;
  color: #475569;
  font-size: 12px;
  font-weight: 400;
  cursor: pointer;
  transition: all 0.2s ease;
}

.seller-payment-add-btn:hover:not(:disabled) {
  color: #d2042d;
  border-color: #d2042d;
}

.seller-payment-add-btn:disabled {
  color: #94a3b8;
  border-color: #cbd5e1;
  background: #fff;
  cursor: not-allowed;
  opacity: 0.9;
}

.seller-payment-schedule-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.seller-payment-row {
  display: grid;
  grid-template-columns:
    minmax(0, 1.5fr) minmax(70px, 0.75fr) minmax(45px, 0.55fr)
    14px;
  align-items: center;
  gap: 7px;
  width: 100%;
}

.seller-payment-date {
  min-width: 0;
}

.seller-payment-date .ant-picker {
  width: 100%;
  height: 34px;
  border: 1px solid #dfe3e8 !important;
  border-radius: 9px;
  background: #fff !important;
  box-shadow: none !important;
}

.seller-payment-date .ant-picker:hover {
  border-color: #bfc5cc !important;
}

.seller-payment-date .ant-picker-focused {
  border-color: #d2042d !important;
  box-shadow: none !important;
}

.seller-payment-date .ant-picker-input > input {
  font-size: 12px;
  color: #101828;
}

.seller-payment-date .ant-picker-input > input::placeholder {
  color: #98a2b3;
}

.seller-payment-percentage {
  height: 34px;
  display: flex;
  align-items: center;
  padding: 0 7px;
  border: 1px solid #dfe3e8;
  border-radius: 9px;
  background: #fff;
  transition: border-color 0.2s ease;
}
.seller-payment-percentage {
  border-color: #bfc5cc !important;
}

.seller-payment-percentage .ant-input-number {
  flex: 1 1;
  width: 100%;
  height: 30px;
  border: none !important;
  background: transparent !important;
  box-shadow: none !important;
}

.seller-payment-percentage .ant-input-number-input {
  height: 30px;
  padding: 0;
  font-size: 12px;
  color: #101828;
}

.seller-payment-percentage > span {
  flex-shrink: 0;
  margin-left: 3px;
  color: #98a2b3;
  font-size: 12px;
}

.seller-payment-percentage .ant-input-number-handler-wrap {
  width: 18px;
  opacity: 1 !important;
  border-left: 1px solid #e5e7eb;
}

.seller-payment-percentage .ant-input-number-handler {
  height: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none !important;
  background: #fff !important;
}

.seller-payment-percentage .ant-input-number-handler-up-inner,
.seller-payment-percentage .ant-input-number-handler-down-inner {
  color: #000 !important;
  font-size: 8px;
}

.seller-payment-amount {
  min-width: 0;
  text-align: right;
  color: #98a2b3;
  font-size: 12px;
  font-weight: 400;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.seller-payment-delete {
  width: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #98a2b3;
  font-size: 12px;
}

.seller-payment-delete .anticon {
  cursor: pointer;
  transition: color 0.2s ease;
}
.seller-payment-delete .anticon:hover {
  color: #d2042d;
}

.seller-payment-total {
  min-height: 34px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-top: 8px;
  padding: 0 12px;
  border: 1px solid #dfe3e8;
  border-radius: 9px;
  background: #f8fafc;
  color: #475569;
  font-size: 12px;
}

.seller-payment-total > span {
  white-space: nowrap;
  font-weight: 700;
}

.seller-payment-total-complete {
  border-color: #86efac;
  background: #f0fdf4;
  color: #008a3e;
}

.seller-payment-check {
  margin-left: 5px;
  font-weight: 600;
  color: #008a3e;
}
/* =========================================================
   TERMS PREVIEW
   ========================================================= */

.messages-terms-preview {
  width: 100%;
  padding-top: 2px;
}

/* Preview hint */

.messages-terms-preview-hint {
  display: flex;
  align-items: center;
  gap: 5px;

  margin: 0 2px 12px;

  color: #98a2b3;
  font-size: 11px;
}

.messages-terms-preview-hint-icon {
  font-size: 12px;
  line-height: 1;
}

/* Seller payment card */

.messages-terms-preview-card {
  border: 2px solid #e0002b;
  border-radius: 16px;

  background: #fff1f3;

  overflow: hidden;
}

/* Header */

.messages-terms-preview-header {
  padding: 14px 16px 8px;
}

.messages-terms-preview-title {
  display: flex;
  align-items: center;
  gap: 8px;

  color: #d2042d;
  font-size: 12px;
  font-weight: 500;
}

.messages-terms-preview-icon {
  width: 28px;
  height: 28px;

  display: inline-flex;
  align-items: center;
  justify-content: center;

  flex-shrink: 0;

  border-radius: 8px;

  background: #d2042d;
  color: #fff;

  font-size: 16px;
  font-weight: 500;
}

/* Payment rows */

.messages-terms-preview-payments {
  padding: 0 16px;
}

.messages-terms-preview-payment {
  min-height: 30px;

  display: flex;
  align-items: center;
  justify-content: space-between;

  border-bottom: 1px solid #f3b8c2;

  color: #475569;
  font-size: 12px;
}

.messages-terms-preview-payment span:last-child {
  color: #101828;
  font-weight: 500;
}

.messages-terms-preview-total {
  min-height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  color: #d2042d;
  font-size: 12px;
  font-weight: 600;
}
.counter-offer-container {
  max-height: 400px;
}
.margin-styles {
  margin-top: 10px !important;
}
.messages-terms-preview-total span:last-child {
  font-weight: 600;
}

.messages-terms-preview-proposed {
  margin-top: 16px;
  padding: 12px;
  border-radius: 10px;
  background: #f8fafc;
  border: 1px solid #edf0f4;
}

.messages-terms-preview-proposed .common-text-101828-12 {
  margin-bottom: 6px;
}
.buyer-proposed-terms {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.buyer-proposed-term-line {
  display: block;
  font-size: 12px;
  color: #64748b;
  line-height: 18px;
}

.buyer-proposed-term-line strong {
  color: #475569;
  font-weight: 500;
}

`, "",{"version":3,"sources":["webpack://./src/features/BuyerFlow/payments-pages/messages/TermsRequestPanel.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,8BAA8B;EAC9B,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,gCAAgC;AAClC;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,eAAe;EACf,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,UAAU;AACZ;AACA;EACE,YAAY;AACd;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,8BAA8B;EAC9B,4BAA4B;EAC5B,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,8BAA8B;EAC9B,4BAA4B;EAC5B,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,0BAA0B;EAC1B,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;;EAE9B,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,4BAA4B;EAC5B,8BAA8B;EAC9B,gCAAgC;AAClC;AACA;EACE,cAAc;EACd,uBAAuB;EACvB,6BAA6B;EAC7B,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;AACA;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAU;EACV,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,SAAO;EACP,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,YAAU;EACV,YAAY;AACd;AACA;EACE,WAAW;EACX,8BAA8B;EAC9B,4BAA4B;EAC5B,8BAA8B;EAC9B,gCAAgC;AAClC;AACA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,8BAA8B;EAC9B,4BAA4B;EAC5B,8BAA8B;EAC9B,gCAAgC;AAClC;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,QAAQ;EACR,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,YAAU;EACV,YAAY;AACd;;AAEA;EACE,YAAU;EACV,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAU;EACV,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,YAAU;EACV,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAU;EACV,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,oCAAoC;EACpC,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,YAAU;EACV,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,WAAW;EACX,YAAY;EACZ,UAAU;EACV,uBAAuB;EACvB,wBAAwB;EACxB,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,SAAO;EACP,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,uBAAuB;EACvB,sBAAsB;AACxB;AACA;;EAEE,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;;;;;EAME,sBAAsB;AACxB;;AAEA;;;;;;EAME,sBAAsB;AACxB;AACA;;EAEE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,gCAAgC;AAClC;AACA;EACE,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,oCAAoC;AACtC;AACA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;AACA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb;;QAEM;EACN,mBAAmB;EACnB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;EAClB,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;AACpC;AACA;EACE,gCAAgC;AAClC;;AAEA;EACE,SAAO;EACP,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;;EAEE,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,2BAA2B;AAC7B;AACA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;AACA;;8DAE8D;;AAE9D;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA,iBAAiB;;AAEjB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;;EAER,kBAAkB;;EAElB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,wBAAwB;;AAExB;EACE,yBAAyB;EACzB,mBAAmB;;EAEnB,mBAAmB;;EAEnB,gBAAgB;AAClB;;AAEA,WAAW;;AAEX;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;;EAER,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;;EAEZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;;EAEvB,cAAc;;EAEd,kBAAkB;;EAElB,mBAAmB;EACnB,WAAW;;EAEX,eAAe;EACf,gBAAgB;AAClB;;AAEA,iBAAiB;;AAEjB;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;;EAEhB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;;EAE9B,gCAAgC;;EAEhC,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB","sourcesContent":[".messages-terms-request-panel {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  min-width: 0;\n}\n\n.messages-terms-request-wrapper {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  min-height: 0;\n  background: #fff;\n  border-left: 1px solid #e5e7eb;\n  width: 30%;\n}\n\n.messages-terms-request-header {\n  min-height: 60px;\n  padding: 12px 16px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-bottom: 1px solid #edf0f4;\n  margin-top: 10px;\n}\n\n.messages-terms-request-header-left {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n.color-text {\n  color: #6366f1 !important;\n}\n\n.messages-terms-close {\n  cursor: pointer;\n  color: #99a1af;\n  font-size: 14px;\n}\n\n.messages-terms-close:hover {\n  color: #d2042d;\n}\n\n.messages-terms-tabs {\n  display: flex;\n  height: 42px;\n  border-bottom: 1px solid #edf0f4;\n}\n\n.messages-terms-tab {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  cursor: pointer;\n  color: #99a1af;\n  font-size: 12px;\n  border-bottom: 2px solid transparent;\n}\n\n.messages-terms-tab-active {\n  color: #d2042d;\n  border-bottom-color: #d2042d;\n}\n\n.messages-terms-request-body {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  padding: 14px 16px;\n}\n\n.messages-terms-product-card {\n  padding: 14px;\n  background: #f8fafc;\n  border: 1px solid #edf0f4;\n  border-radius: 10px;\n  margin-bottom: 12px;\n}\n\n.messages-terms-product-card .common-text-99a1af-11 {\n  display: block;\n  margin-bottom: 4px;\n}\n\n.messages-terms-section-card {\n  border: 1px solid #e5e9ef;\n  border-radius: 10px;\n  overflow: hidden;\n}\n\n.messages-terms-section-card > .common-text-101828-14-500 {\n  display: block;\n  padding: 14px;\n  border-bottom: 1px solid #edf0f4;\n}\n\n.messages-terms-info-row {\n  min-height: 44px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-bottom: 1px solid #edf0f4;\n}\n\n.messages-terms-info-row:last-child {\n  border-bottom: none;\n}\n\n.messages-terms-info-box {\n  margin-top: 12px;\n  padding: 12px;\n  border-radius: 9px;\n  background: #eef6ff;\n  border: 1px solid #d9eaff;\n}\n\n.messages-terms-request-card {\n  border: 1px solid #e5e9ef;\n  border-radius: 10px;\n}\n\n.messages-terms-request-total {\n  padding: 14px;\n  display: flex;\n  justify-content: space-between;\n  border-bottom: 1px solid #edf0f4;\n}\n\n.messages-terms-total {\n  text-align: right;\n  width: 35%;\n}\n.messages-terms-form-section {\n  padding: 0px;\n}\n.padding-styles {\n  padding: 14px !important;\n}\n.messages-terms-date-labels {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 8px;\n  margin-bottom: 5px;\n}\n.alignment-footer {\n  display: flex;\n  align-items: center;\n}\n.messages-terms-date-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 8px;\n}\n\n.messages-terms-date-row .ant-picker {\n  width: 100%;\n}\n\n.messages-terms-payment-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 10px;\n}\n\n.messages-terms-installment-heading {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 6px;\n  color: #99a1af;\n  font-size: 12px;\n}\n\n.messages-terms-installment-row {\n  display: flex;\n  justify-content: space-between;\n  gap: 8px;\n  align-items: flex-start;\n  margin-bottom: 8px;\n  position: relative;\n}\n\n.messages-installment-name {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  min-width: 0;\n}\n\n.messages-installment-number {\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: #fff0f3;\n  color: #d2042d;\n  font-size: 10px;\n  font-weight: 600;\n}\n\n.messages-terms-installment-row .ant-picker {\n  width: 100%;\n  background: #ffffff !important;\n  border-width: 1px !important;\n  border-style: solid !important;\n  border-color: #d9d9d9 !important;\n}\n\n.messages-installment-percentage {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  align-items: center;\n}\n\n.messages-installment-percentage .ant-input-number {\n  width: 100%;\n  background: #ffffff !important;\n  border-width: 1px !important;\n  border-style: solid !important;\n  border-color: #d9d9d9 !important;\n}\n\n.messages-installment-delete {\n  position: static;\n  right: -20px;\n  color: #d1d5dc;\n  cursor: pointer;\n}\n\n.messages-add-installment-button {\n  margin-top: 6px;\n  height: 34px;\n  border: 1px dashed #d2042d;\n  color: #d2042d;\n  background: #fff;\n}\n\n.messages-add-installment-button:hover {\n  color: #d2042d !important;\n  border-color: #d2042d !important;\n}\n\n.messages-terms-allocation {\n  margin-top: 10px;\n  border-radius: 8px;\n  background: #f8fafc;\n  overflow: hidden;\n  border: 1px solid #e5e7eb;\n}\n\n.messages-terms-allocation-info {\n  min-height: 32px;\n  padding: 7px 10px;\n\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n\n  gap: 8px;\n}\n\n.messages-terms-allocation-progress {\n  width: 100%;\n  height: 5px;\n  background: #e5e7eb;\n  overflow: hidden;\n}\n\n.messages-terms-allocation-progress-fill {\n  height: 100%;\n  background: #d2042d;\n  transition: width 0.25s ease;\n}\n\n.messages-terms-note-input {\n  margin-top: 8px;\n  background: #ffffff !important;\n  border-width: 1px !important;\n  border-style: solid !important;\n  border-color: #d9d9d9 !important;\n}\n.messages-terms-request-footer {\n  flex-shrink: 0;\n  padding: 10px 16px 14px;\n  border-top: 1px solid #edf0f4;\n  background: #fff;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.messages-send-terms-button {\n  width: 100%;\n  height: 38px;\n  gap: 0px !important;\n}\n\n.messages-terms-cancel-button {\n  width: 100%;\n  color: #4a5565;\n}\n\n.messages-terms-installment-heading {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 6px;\n  color: #99a1af;\n  font-size: 12px;\n}\n.messages-terms-installment-heading span:nth-child(1) {\n  flex: 1;\n  min-width: 0;\n  text-align: left;\n}\n\n.messages-terms-installment-heading span:nth-child(2) {\n  flex: 1.15;\n  min-width: 0;\n  text-align: center;\n}\n\n.messages-terms-installment-heading span:nth-child(3) {\n  flex: 1;\n  min-width: 0;\n  text-align: center;\n}\n\n.messages-terms-installment-heading span:nth-child(4) {\n  flex: 0 0 16px;\n}\n\n.messages-terms-installment-row {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  width: 100%;\n  min-width: 0;\n  margin-bottom: 8px;\n}\n.messages-installment-name {\n  flex: 1;\n  min-width: 28%;\n  display: flex;\n  align-items: center;\n  gap: 7px;\n}\n.messages-installment-number {\n  flex: 0 0 20px;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: #fff0f3;\n  color: #d2042d;\n  font-size: 10px;\n  font-weight: 600;\n}\n\n.messages-installment-name .common-text-101828-12 {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.messages-installment-date {\n  flex: 1.15;\n  min-width: 0;\n}\n.messages-installment-date .ant-picker {\n  width: 100%;\n  background: #ffffff !important;\n  border-width: 1px !important;\n  border-style: solid !important;\n  border-color: #d9d9d9 !important;\n}\n.messages-installment-percentage {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 2px;\n}\n\n.messages-installment-percentage .ant-input-number {\n  width: 100%;\n  background: #ffffff !important;\n  border-width: 1px !important;\n  border-style: solid !important;\n  border-color: #d9d9d9 !important;\n}\n.messages-installment-percentage .location-grey-text-12 {\n  width: 100%;\n  text-align: center;\n}\n\n.messages-installment-delete-wrapper {\n  flex: 0 0 16px;\n  width: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding-top: 5px;\n}\n\n.messages-installment-delete:hover {\n  color: #e53b58 !important;\n}\n\n.messages-terms-installment-heading {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  gap: 8px;\n  margin-bottom: 6px;\n  color: #99a1af;\n  font-size: 11px;\n  line-height: 14px;\n}\n\n.installment-col-name {\n  flex: 1.05;\n  min-width: 0;\n}\n\n.installment-col-date {\n  flex: 1.15;\n  min-width: 0;\n  text-align: center;\n}\n\n.installment-col-payment {\n  flex: 0.95;\n  min-width: 0;\n  text-align: center;\n}\n\n.installment-col-delete {\n  flex: 0 0 12px;\n  width: 12px;\n}\n\n.messages-terms-installment-row {\n  display: flex;\n  align-items: flex-start;\n  width: 100%;\n  min-width: 0;\n  gap: 8px;\n  margin-bottom: 8px;\n}\n\n.messages-installment-name {\n  flex: 1.05;\n  min-width: 0;\n  height: 42px;\n  display: flex;\n  align-items: center;\n  gap: 7px;\n}\n\n.messages-installment-name .common-text-101828-12 {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.messages-installment-number {\n  flex: 0 0 20px;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: #fff0f3;\n  color: #d2042d;\n  font-size: 10px;\n  font-weight: 600;\n}\n\n.messages-installment-date {\n  flex: 1.15;\n  min-width: 0;\n  height: 42px;\n  display: flex;\n  align-items: center;\n}\n.messages-installment-date .ant-picker {\n  width: 100%;\n  height: 32px;\n  background: #fff !important;\n  border: 1px solid #d9d9d9 !important;\n  border-radius: 8px;\n  box-shadow: none !important;\n}\n\n.messages-installment-percentage {\n  flex: 0.95;\n  min-width: 0;\n  height: 50px;\n  display: flex;\n  flex-direction: column;\n  border: 1px solid #d9d9d9;\n  border-radius: 8px;\n  overflow: hidden;\n  background: #fff;\n}\n\n.messages-installment-percent-input {\n  height: 23px;\n  display: flex;\n  align-items: center;\n  padding: 0 7px;\n  background: #fff;\n}\n\n.messages-installment-percent-input .ant-input-number {\n  flex: 1;\n  width: 100%;\n  height: 22px;\n  padding: 0;\n  border: none !important;\n  outline: none !important;\n  background: transparent !important;\n  box-shadow: none !important;\n}\n\n.messages-installment-percent-input .ant-input-number-input {\n  height: 22px;\n  padding: 0;\n  font-size: 12px;\n  color: #101828;\n}\n\n.messages-installment-percent-symbol {\n  flex: 0 0 auto;\n  margin-left: 4px;\n  color: #99a1af;\n  font-size: 12px;\n}\n\n.messages-installment-amount {\n  height: 25px;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-top: 1px solid #ffd1d8;\n  background: #fff1f3;\n  color: #d2042d;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.messages-installment-delete-wrapper {\n  flex: 0 0 12px;\n  width: 12px;\n  height: 50px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.messages-installment-percent-input .ant-input-number {\n  flex: 1;\n  width: 100%;\n  height: 22px;\n  border: none !important;\n  background: #fff !important;\n  box-shadow: none !important;\n}\n\n.messages-installment-percent-input .ant-input-number-input {\n  height: 22px;\n  padding: 0 4px;\n  font-size: 12px;\n  color: #101828;\n}\n\n.messages-installment-percent-input .ant-input-number-handler-wrap {\n  width: 20px;\n  background: #fff !important;\n  border-left: 1px solid #e5e7eb;\n  opacity: 1 !important;\n}\n\n.messages-installment-percent-input .ant-input-number-handler {\n  height: 11px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #fff !important;\n  border: none !important;\n  color: #000 !important;\n}\n.messages-installment-percent-input .ant-input-number-handler-up-inner,\n.messages-installment-percent-input .ant-input-number-handler-down-inner {\n  color: #000 !important;\n  font-size: 9px;\n}\n\n.messages-installment-percent-input .ant-input-number-handler:hover {\n  background: #f5f5f5 !important;\n}\n\n.messages-installment-percent-input\n  .ant-input-number-handler:hover\n  .ant-input-number-handler-up-inner,\n.messages-installment-percent-input\n  .ant-input-number-handler:hover\n  .ant-input-number-handler-down-inner {\n  color: #000 !important;\n}\n\n.messages-installment-percent-input\n  .ant-input-number-handler-down-disabled\n  .ant-input-number-handler-down-inner,\n.messages-installment-percent-input\n  .ant-input-number-handler-up-disabled\n  .ant-input-number-handler-up-inner {\n  color: #999 !important;\n}\n.messages-installment-percent-input .ant-input-number-handler-up-disabled,\n.messages-installment-percent-input .ant-input-number-handler-down-disabled {\n  visibility: hidden;\n}\n.messages-terms-section-header {\n  display: flex;\n  align-items: center;\n  min-height: 38px;\n  padding: 0 14px;\n  background: #f8fafc;\n  border-bottom: 1px solid #edf0f4;\n}\n\n.messages-terms-section-header .common-text-101828-14 {\n  line-height: 16px;\n}\n.messages-terms-info-row {\n  min-height: 44px;\n  padding: 8px 14px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-bottom: 1px solid #edf0f4;\n}\n\n.messages-terms-info-row:last-child {\n  border-bottom: none;\n}\n.messages-terms-section-header {\n  display: flex;\n  align-items: center;\n  height: 38px;\n  padding: 0 14px;\n  background: #f8fafc;\n  border-bottom: 1px solid #edf0f4;\n}\n.messages-terms-request-body {\n  flex: 1 1;\n  min-height: 0;\n  overflow-y: auto;\n  padding: 14px 16px;\n  scrollbar-width: thin;\n  scrollbar-color: #98a2b3 transparent;\n}\n.messages-terms-request-body::-webkit-scrollbar {\n  width: 6px;\n}\n\n.messages-terms-request-body::-webkit-scrollbar-track {\n  background: transparent;\n}\n.messages-terms-request-body::-webkit-scrollbar-thumb {\n  background: #98a2b3;\n  border-radius: 10px;\n}\n.messages-terms-request-body::-webkit-scrollbar-thumb:hover {\n  background: #667085;\n}\n\n.messages-terms-allocation-complete {\n  background: #f0fdf4;\n  border-color: #16a34a;\n}\n\n.messages-terms-allocation-complete\n  .messages-terms-allocation-info\n  .location-grey-text-12 {\n  color: #008a3e !important;\n}\n\n.messages-terms-allocation-complete\n  .messages-terms-allocation-info\n  .common-text-101828-12-500 {\n  color: #008a3e !important;\n}\n\n.messages-terms-allocation-complete .messages-terms-allocation-progress {\n  background: #dcfce7;\n}\n\n.messages-terms-allocation-complete .messages-terms-allocation-progress-fill {\n  background: #16a34a;\n}\n.edit-preview-toggle {\n  display: flex;\n  width: 100%;\n  height: 30px;\n  border: 1px solid #d9d9d9;\n  border-radius: 10px;\n  overflow: hidden;\n  background: #fff;\n}\n\n.toggle-btn {\n  flex: 1;\n  border: none;\n  background: transparent;\n  color: #4b5563;\n  font-size: 12px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.toggle-btn.active {\n  background: #d50032;\n  color: #fff;\n  font-weight: 600;\n}\n\n.toggle-btn:first-child {\n  border-radius: 9px 0 0 9px;\n}\n\n.toggle-btn:last-child {\n  border-radius: 0 9px 9px 0;\n}\n\n.toggle-btn:focus {\n  outline: none;\n}\n\n.seller-payment-schedule {\n  width: 100%;\n  margin-top: 8px;\n}\n\n.seller-payment-schedule-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 8px;\n}\n\n.seller-payment-add-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 5px;\n  height: 28px;\n  padding: 0 10px;\n  border: 1px dashed #cbd5e1;\n  border-radius: 9px;\n  background: #fff;\n  color: #475569;\n  font-size: 12px;\n  font-weight: 400;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.seller-payment-add-btn:hover:not(:disabled) {\n  color: #d2042d;\n  border-color: #d2042d;\n}\n\n.seller-payment-add-btn:disabled {\n  color: #94a3b8;\n  border-color: #cbd5e1;\n  background: #fff;\n  cursor: not-allowed;\n  opacity: 0.9;\n}\n\n.seller-payment-schedule-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.seller-payment-row {\n  display: grid;\n  grid-template-columns:\n    minmax(0, 1.5fr) minmax(70px, 0.75fr) minmax(45px, 0.55fr)\n    14px;\n  align-items: center;\n  gap: 7px;\n  width: 100%;\n}\n\n.seller-payment-date {\n  min-width: 0;\n}\n\n.seller-payment-date .ant-picker {\n  width: 100%;\n  height: 34px;\n  border: 1px solid #dfe3e8 !important;\n  border-radius: 9px;\n  background: #fff !important;\n  box-shadow: none !important;\n}\n\n.seller-payment-date .ant-picker:hover {\n  border-color: #bfc5cc !important;\n}\n\n.seller-payment-date .ant-picker-focused {\n  border-color: #d2042d !important;\n  box-shadow: none !important;\n}\n\n.seller-payment-date .ant-picker-input > input {\n  font-size: 12px;\n  color: #101828;\n}\n\n.seller-payment-date .ant-picker-input > input::placeholder {\n  color: #98a2b3;\n}\n\n.seller-payment-percentage {\n  height: 34px;\n  display: flex;\n  align-items: center;\n  padding: 0 7px;\n  border: 1px solid #dfe3e8;\n  border-radius: 9px;\n  background: #fff;\n  transition: border-color 0.2s ease;\n}\n.seller-payment-percentage {\n  border-color: #bfc5cc !important;\n}\n\n.seller-payment-percentage .ant-input-number {\n  flex: 1;\n  width: 100%;\n  height: 30px;\n  border: none !important;\n  background: transparent !important;\n  box-shadow: none !important;\n}\n\n.seller-payment-percentage .ant-input-number-input {\n  height: 30px;\n  padding: 0;\n  font-size: 12px;\n  color: #101828;\n}\n\n.seller-payment-percentage > span {\n  flex-shrink: 0;\n  margin-left: 3px;\n  color: #98a2b3;\n  font-size: 12px;\n}\n\n.seller-payment-percentage .ant-input-number-handler-wrap {\n  width: 18px;\n  opacity: 1 !important;\n  border-left: 1px solid #e5e7eb;\n}\n\n.seller-payment-percentage .ant-input-number-handler {\n  height: 14px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: none !important;\n  background: #fff !important;\n}\n\n.seller-payment-percentage .ant-input-number-handler-up-inner,\n.seller-payment-percentage .ant-input-number-handler-down-inner {\n  color: #000 !important;\n  font-size: 8px;\n}\n\n.seller-payment-amount {\n  min-width: 0;\n  text-align: right;\n  color: #98a2b3;\n  font-size: 12px;\n  font-weight: 400;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.seller-payment-delete {\n  width: 14px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #98a2b3;\n  font-size: 12px;\n}\n\n.seller-payment-delete .anticon {\n  cursor: pointer;\n  transition: color 0.2s ease;\n}\n.seller-payment-delete .anticon:hover {\n  color: #d2042d;\n}\n\n.seller-payment-total {\n  min-height: 34px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  margin-top: 8px;\n  padding: 0 12px;\n  border: 1px solid #dfe3e8;\n  border-radius: 9px;\n  background: #f8fafc;\n  color: #475569;\n  font-size: 12px;\n}\n\n.seller-payment-total > span {\n  white-space: nowrap;\n  font-weight: 700;\n}\n\n.seller-payment-total-complete {\n  border-color: #86efac;\n  background: #f0fdf4;\n  color: #008a3e;\n}\n\n.seller-payment-check {\n  margin-left: 5px;\n  font-weight: 600;\n  color: #008a3e;\n}\n/* =========================================================\n   TERMS PREVIEW\n   ========================================================= */\n\n.messages-terms-preview {\n  width: 100%;\n  padding-top: 2px;\n}\n\n/* Preview hint */\n\n.messages-terms-preview-hint {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n\n  margin: 0 2px 12px;\n\n  color: #98a2b3;\n  font-size: 11px;\n}\n\n.messages-terms-preview-hint-icon {\n  font-size: 12px;\n  line-height: 1;\n}\n\n/* Seller payment card */\n\n.messages-terms-preview-card {\n  border: 2px solid #e0002b;\n  border-radius: 16px;\n\n  background: #fff1f3;\n\n  overflow: hidden;\n}\n\n/* Header */\n\n.messages-terms-preview-header {\n  padding: 14px 16px 8px;\n}\n\n.messages-terms-preview-title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n\n  color: #d2042d;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.messages-terms-preview-icon {\n  width: 28px;\n  height: 28px;\n\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n\n  flex-shrink: 0;\n\n  border-radius: 8px;\n\n  background: #d2042d;\n  color: #fff;\n\n  font-size: 16px;\n  font-weight: 500;\n}\n\n/* Payment rows */\n\n.messages-terms-preview-payments {\n  padding: 0 16px;\n}\n\n.messages-terms-preview-payment {\n  min-height: 30px;\n\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n\n  border-bottom: 1px solid #f3b8c2;\n\n  color: #475569;\n  font-size: 12px;\n}\n\n.messages-terms-preview-payment span:last-child {\n  color: #101828;\n  font-weight: 500;\n}\n\n.messages-terms-preview-total {\n  min-height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 16px;\n  color: #d2042d;\n  font-size: 12px;\n  font-weight: 600;\n}\n.counter-offer-container {\n  max-height: 400px;\n}\n.margin-styles {\n  margin-top: 10px !important;\n}\n.messages-terms-preview-total span:last-child {\n  font-weight: 600;\n}\n\n.messages-terms-preview-proposed {\n  margin-top: 16px;\n  padding: 12px;\n  border-radius: 10px;\n  background: #f8fafc;\n  border: 1px solid #edf0f4;\n}\n\n.messages-terms-preview-proposed .common-text-101828-12 {\n  margin-bottom: 6px;\n}\n.buyer-proposed-terms {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.buyer-proposed-term-line {\n  display: block;\n  font-size: 12px;\n  color: #64748b;\n  line-height: 18px;\n}\n\n.buyer-proposed-term-line strong {\n  color: #475569;\n  font-weight: 500;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
